import {
	OPEN_COPY_FILTER_MODAL,
	CLOSE_COPY_FILTER_MODAL,
	type Action,
} from '../../actions/copy-filter-modal/index.tsx';
import type { CopyFilterModalState } from './types.tsx';

export const initialState: CopyFilterModalState = {
	isCopyFilterModalOpen: false,
};

const copyFilterModal = (
	state: CopyFilterModalState = initialState,
	action: Action,
): CopyFilterModalState => {
	switch (action.type) {
		case OPEN_COPY_FILTER_MODAL: {
			return {
				isCopyFilterModalOpen: true,
			};
		}

		case CLOSE_COPY_FILTER_MODAL: {
			return {
				isCopyFilterModalOpen: false,
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default copyFilterModal;
